/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxOpenDocsIcon24Solid = forwardRef('ArchiveBoxOpenDocsIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 0a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 5.5A2.5 2.5 0 0 1 7.5 3h9A2.5 2.5 0 0 1 19 5.5V8h1a1 1 0 0 1 1 1v9.5a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 3 18.5V9a1 1 0 0 1 1-1h1V5.5Zm12 0V8H7V5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5ZM9 12a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z" })));
});
